<template>
  <v-container class="pa-0 mt-3">
    <v-row
      no-gutters
      class="px-8 text-grey text-body-1 mb-n1"
      style="opacity: 0.55"
      >Sharings</v-row
    >

    <div
      no-gutters
      v-for="sharingActivity in sharingActivities"
      :key="sharingActivity.id"
      class="px-3"
    >
      <PlantSharing
        v-if="sharingActivity.status"
        :plant="sharingActivity"
        @toggleLove="toggleLove"
        :self="self"
      />
      <TipSharing
        v-if="sharingActivity.content"
        :tip="sharingActivity"
        @toggleLove="toggleLove"
        :self="self"
      />
    </div>

    <div v-intersect.quiet="onIntersect"></div>

    <div class="px-6" v-if="sharingActivitiesPending">
      <v-skeleton-loader
        type="image"
        class="my-4 rounded-xl"
        v-for="n in 2"
        :key="n"
        height="200"
        width="100%"
      ></v-skeleton-loader>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import PlantSharing from "@/components/activity/PlantSharing.vue";
import TipSharing from "@/components/activity/TipSharing.vue";

export default {
  name: "Sharings",
  components: {
    PlantSharing,
    TipSharing,
  },
  mounted() {
    this.$store.dispatch("sharingActivities/getFirstSharingActivities");
  },

  computed: {
    ...mapState("sharingActivities", [
      "sharingActivities",
      "sharingActivitiesPending",
    ]),
    ...mapState("self", ["self"]),
  },
  methods: {
    onIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.$store.dispatch("sharingActivities/getNextSharingActivities");
      }
    },
    toggleLove(params, item) {
      if (item.loversId.includes(this.self.id)) {
        item.loversId = item.loversId.filter((i) => {
          return i !== this.self.id;
        });
      } else {
        item.loversId.push(this.self.id);
      }
      this.$store.dispatch("lovers/toggleLove", params);
    },
  },
};
</script>

<style >
.container-columns {
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}
.container-columns::-webkit-scrollbar {
  height: 10px;

  color: var(--v-primary-base) !important;
}
.container-columns::-webkit-scrollbar-track {
  border-radius: 10px;
  margin-left: 30px;
  margin-right: 30px;
}
.container-columns::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(194, 194, 194, 0.2);
}

.move-left-item {
  transition: all 0.5s;
}
.move-left-enter,
.move-left-leave-to {
  opacity: 0;
  transform: translateX(50px);
}
.move-left-leave-active {
  position: absolute;
  z-index: -1;
}
</style>